import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/Tabs';
import RSSFeed from '../../components/RSSFeed';
import SavedRSSItems from '../../components/SavedRSSItems';
import RSSSourceManager from '../../components/RSSSourceManager';
import { RssFeedItem } from '../../lib/rss.service';
import { Rss, Bookmark, Settings } from 'lucide-react';

const RSSFeedManager: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState('feed');
  const [selectedItem, setSelectedItem] = useState<RssFeedItem | null>(null);

  const handleSelectItem = (item: RssFeedItem) => {
    setSelectedItem(item);
  };

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">RSS Feed Manager</h1>
        <p className="mt-1 text-gray-600">
          Browse, save, and manage financial news from various sources
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <Tabs value={selectedTab} onValueChange={setSelectedTab} className="w-full">
            <TabsList className="mb-6">
              <TabsTrigger value="feed" className="flex items-center">
                <Rss className="h-4 w-4 mr-2" />
                News Feed
              </TabsTrigger>
              <TabsTrigger value="saved" className="flex items-center">
                <Bookmark className="h-4 w-4 mr-2" />
                Saved Items
              </TabsTrigger>
              <TabsTrigger value="sources" className="flex items-center">
                <Settings className="h-4 w-4 mr-2" />
                Manage Sources
              </TabsTrigger>
            </TabsList>
            
            <TabsContent value="feed">
              <RSSFeed onSelectItem={handleSelectItem} />
            </TabsContent>
            
            <TabsContent value="saved">
              <SavedRSSItems />
            </TabsContent>
            
            <TabsContent value="sources">
              <RSSSourceManager />
            </TabsContent>
          </Tabs>
        </div>

        {/* Selected Item Preview */}
        <div className="lg:col-span-1">
          {selectedItem ? (
            <div className="bg-white rounded-lg shadow-sm p-6 sticky top-6">
              <h2 className="text-xl font-semibold mb-4">{selectedItem.title}</h2>
              
              <div className="flex items-center text-sm text-gray-500 mb-4">
                <span className="font-medium text-gray-700">{selectedItem.source?.name || selectedItem.source}</span>
                <span className="mx-2">•</span>
                <span>{new Date(selectedItem.published_at).toLocaleDateString()}</span>
              </div>
              
              <div className="prose prose-sm max-w-none mb-4">
                <div dangerouslySetInnerHTML={{ __html: selectedItem.content || selectedItem.description || '' }} />
              </div>
              
              <a
                href={selectedItem.link}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary w-full justify-center py-2"
              >
                Read Full Article
              </a>
            </div>
          ) : (
            <div className="bg-white rounded-lg shadow-sm p-6 text-center">
              <Rss className="h-12 w-12 text-gray-300 mx-auto mb-4" />
              <h3 className="text-lg font-medium text-gray-900 mb-2">No Article Selected</h3>
              <p className="text-gray-500">
                Click on an article from the feed to view its details here
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RSSFeedManager;